import {BuilderContext, registerWidgetType} from "../../builder/WidgetRegistry";
import React from "react";
import {IncomingPayments} from "../../IncomingPayments";
import {useOnStoreReady, useUpdateOnGlobalContextChange} from "../../builder/widgets/commons";


registerWidgetType({
    typeId: 'JLLDemo-incoming-payments',
    metadata: {
      name: 'JLLDemo Incoming Payments',
      description: '',
      icon: 'app',
    },
    defaultConfig: {
      label: 'Param',
      type: "number",
      addToStore: false,
    },
    renderConfig: (config: any, context: BuilderContext, setConfig: (config: string) => void) => {
      return  <></>
    },
    render: (config: any, context: BuilderContext) => {
      return  <IncomingPaymentsWidget context={context}/>
    }
  }
)

function IncomingPaymentsWidget({context}:{context: BuilderContext}) {
  useOnStoreReady(context);
  useUpdateOnGlobalContextChange(context);

  return  <IncomingPayments
    lenderField="source_projectName"
    interestLineItem={"Debt Schedule - Interest Payment"}
    principalLineItem={"Debt Schedule - Principal Payment"}
    store={context.appContext.getStore()}
  />

}